import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../ModalDialog';
import './_styles_/VariablesProvidingPopup.css';

VariablesProvidingPopup.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    variablesProvidingComp: PropTypes.func.isRequired,
    headline: PropTypes.string,
};

export const FULL_SCREEN_CLS_NAME = 'variables-providing-popup-dialog--full-screen';

function VariablesProvidingPopup(props) {
    const {
        onConfirm,
        onCancel,
        variablesProvidingComp,
        headline = null,
    } = props;
    const { t } = useTranslation();
    const [variables, setVariables] = useState(null);
    const [isValid, setValid] = useState(false);
    // The content decides, since only it knows whether it currently shows something that needs the screen.
    const [isFullScreen, setFullScreen] = useState(false);
    const onConfirmWithVariables = () => {
        onConfirm(variables);
    };
    // Toggled on the dialog itself, since wrapping it would remount the content and lose its state.
    const dialogClassName = isFullScreen ? `variables-providing-popup-dialog ${FULL_SCREEN_CLS_NAME}` : 'variables-providing-popup-dialog';
    return (
        <ModalDialog onCancel={onCancel}>
            <div // NOSONAR javascript:S6819 - role="dialog" is the dialog markup shared by every popup of the app
                className={dialogClassName}
                role="dialog"
                aria-modal
            >
                <h4>{headline ? headline : t('misc.provide-additional-values')}</h4>
                <div className="variables-providing-popup-dialog--fields">
                    {variablesProvidingComp(setVariables, setValid, setFullScreen)}
                </div>
                <div className="buttons">
                    <button
                        type="button"
                        className="continue-button button-filled-red button"
                        onClick={onConfirmWithVariables}
                        disabled={!isValid}
                    >
                        {t('button.continue')}
                    </button>
                    <button
                        type="button"
                        className="cancel-button button-bordered button"
                        onClick={onCancel}
                    >
                        {t('button.cancel')}
                    </button>
                </div>
            </div>
        </ModalDialog>
    );
}

export default VariablesProvidingPopup;
